import React from "react";
import { Typography } from "@/components/Typography";

interface PdfHeaderProps {
  pdfName?: string;
  pdfDescription?: string;
}

export const PdfHeader: React.FC<PdfHeaderProps> = ({ pdfName, pdfDescription }) => {
  return (
    <>
      <Typography
        Tag="p"
        spacing={4}
        size="xl"
        classname="u-bold pdf-template__name"
      >
        {pdfName}
      </Typography>
      <Typography
        Tag="p"
        spacing={4}
        classname="body-s"
      >
        {pdfDescription}
      </Typography>
    </>
  );
};
